import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { postLaunchEvent } from "@/api/launch";
import { useI18n } from "@/i18n";

// Reusable locked/upgrade surface. Fires a paywall_view analytics event on mount.
export function Paywall({ title, body, feature }: { title?: string; body?: string; feature?: string }) {
  const { lang } = useI18n();
  useEffect(() => { postLaunchEvent("paywall_view", feature ? { feature } : undefined); }, [feature]);
  return (
    <div data-testid="paywall" className="rounded-2xl border border-gold/25 bg-gold/[0.05] p-6 text-center">
      <span className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-gold/15 text-gold-300"><Lock className="h-5 w-5" /></span>
      <h3 className="mt-4 text-lg font-bold text-foreground">{title || (lang === "tr" ? "Bu özellik planına dahil değil" : "This feature isn't in your plan")}</h3>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">{body || (lang === "tr" ? "Daha üst bir plana geçerek bu özelliği açabilirsin." : "Upgrade your plan to unlock this feature.")}</p>
      <Link to="/app/membership" data-testid="paywall-cta" className="mt-5 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-atlas-500 to-atlas-600 px-5 py-2.5 text-sm font-bold text-atlas-ink transition hover:shadow-glow">
        <Sparkles className="h-4 w-4" /> {lang === "tr" ? "Planları Gör" : "View Plans"}
      </Link>
    </div>
  );
}
